import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { memo, useCallback } from 'react';
import { Col } from 'react-bootstrap';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { Flex, Tag } from 'antd';
import { formatDate, isValidDate } from '../../utils';
import { AssetCategory as AssetCategoryType } from '../../models/generics';
import AssetCategory from '../common/AssetCategory';
import classNames from 'classnames';
import AppBadge from '../common/AppBadge';

const iconsMap: Record<string, IconDefinition> = {
  dataset: solid('database'),
  model: solid('graduation-cap'),
  batch: solid('code'),
  service: solid('code'),
}

type Props = {
  title: string;
  name?: string;
  type: string;
  version?: string;
  trailing?: string;
  vertical?: boolean;
  category?: AssetCategoryType;
}

function NodeContent({ title, type, version, trailing, vertical, category }: Props) {
  const getNodeIcon = useCallback(() => {
    // TODO remove/improve this?
    if (trailing === 'endpoint') return solid('globe');
    return iconsMap[type] || solid('cog');
  }, [trailing, type]);

  return (
    <Flex align="center">
      {!vertical && <FontAwesomeIcon icon={getNodeIcon()} />}
      <Col className="overflow-hidden">
        {vertical && (
          <div className="node-pills mb-1">
            <Tag className={classNames("asset-type-tag", type)} icon={<FontAwesomeIcon icon={getNodeIcon()} className="me-1" />}>{type}</Tag>
            {category && <AssetCategory category={category} />}
            {version && (
              <AppBadge color="#666" tooltip="Version">
                <FontAwesomeIcon icon={solid('tag')} />
                <span className="ms-1">{version}</span>
              </AppBadge>
            )}
            {trailing && <AppBadge>{isValidDate(trailing) ? formatDate(trailing) : trailing}</AppBadge>}
          </div>
        )}
        <Flex align="center" vertical={vertical}>
          <Col className={classNames("px-2 overflow-hidden", { "pb-1": vertical })}>
            <div className="node-title text-truncate">{title}</div>
          </Col>
          {!vertical && (
            <>
              {trailing && <small className="text-secondary font-xs">{isValidDate(trailing) ? formatDate(trailing) : trailing}</small>}
              {version && (
                <small className="fw-bold text-secondary font-xs">
                  <FontAwesomeIcon icon={solid('tag')} />
                  <span className="ms-1">{version}</span>
                </small>
              )}
            </>
          )}
        </Flex>
      </Col>
    </Flex>
  )
}

export default memo(NodeContent);
